import { inject, injectable, optional } from '@servicetitan/react-ioc';

import { Logger, USE_LOGGER_TOKEN } from '../utils/logger';
import { USE_WINDOW_TOKEN } from '../utils/tokens';

export enum ErrorStatus {
    VALIDATIONFAIL = 400,
    BADPAYLOAD = 700,
    UNKNOWN = 800,
}

export enum ErrorMessages {
    FieldLoadPage = 'Wrong loading option',
    InstanceNotProvided = 'Widget instance id is not provided',
    UnableInit = 'Unable initialized widget',
    Unexpected = 'Runtime error occur',
}

interface CustomError {
    logger?: boolean;
    statusCode: ErrorStatus;
    statusText: ErrorMessages;
    error?: any;
}

type GlobalWindow = Window | undefined;

@injectable()
export class ExceptionStore {
    // currently no usage of stacked errors, collecting them in case of any thrown error, later if we need to handle them or to attach to some analytics tool
    private stack: CustomError[] = [];

    constructor(
        @inject(USE_LOGGER_TOKEN) @optional() private readonly logger: Logger,
        @inject(USE_WINDOW_TOKEN) @optional() private readonly global: GlobalWindow = undefined
    ) {
        this.register(this.global);
    }

    stashError = (params: CustomError, error?: any) => {
        this.logger?.error(params.statusText, error ?? '');
        const errorSummary = { ...params, error: JSON.stringify(error) };
        this.stack.push(errorSummary);
    };

    private register = (global?: Window) => {
        global?.addEventListener('error', error => {
            this.stashError(
                {
                    statusCode: ErrorStatus.UNKNOWN,
                    statusText: ErrorMessages.Unexpected,
                },
                error
            );
        });
    };
}
